export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Scrivi un post...',
  blogsFeedSearchInputPlaceholder: 'Cerca',
  blogsFeedPostOwnerCurtainEditTitle: 'Modifica post',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Elimina post',
  blogsFeedEditedPostSavedAlertText: 'Post salvato!',
  blogsFeedEditedPostDeletedAlertText: 'Post eliminato!',
  blogsFeedShareCurtainOptionTitle: 'Copia link',
  blogsFeedPostLinkCopiedAlertText: 'Link copiato!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Copia link',
  blogsFeedOthersPosLinkCopiedAlertText: 'Link copiato!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Segnala contenuto',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Elimina post',
  blogsFeedPostDeletePopupTitle: 'Elimina',
  blogsFeedPostDeletePopupText: 'Eliminare questo post?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Annulla',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Conferma',
  blogsFeedPostDeeletedAlertText: 'Post eliminato!',
  blogsPostDetailsHeaderTitle: 'Post',
  postFeedPostLikesText: 'Mi piace',
  postFeedPostCommentsText: 'Commenti',
  postFeedPostNoLikesText: 'Non ci sono ancora Mi piace',
  postFeedPostLeaveFirstLikeText: 'Puoi essere il primo a mettere Mi piace',
  blogsFeedPostDetailsNoCommentsText: 'Non ci sono ancora commenti',
  blogsFeedPostDetailsFirstCommentText: 'Puoi essere il primo a commentare',
  blogsFeedPostDetailsShareOptionTitle: 'Copia link',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Link copiato!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copia link',
  blogsFeedPostDetailsCopiedAlertText: 'Link copiato!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Segnala contenuto',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Segnala',
  blogsPostDetailsReportedCurtainText: 'Contenuto segnalato',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Modifica commento',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Elimina commento',
  blogsPostDetailsEditedCommentSavedAlertText: 'Commento salvato!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Elimina commento',
  postDetailsOtherUsersCommentDeletadAlertText: 'Commento eliminato!',
  postDetailsDeleteCommentPopupTitle: 'Elimina',
  postDetailsDeleteCommentPopupText: 'Eliminare questo commento?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Annulla',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Conferma',
  postDetailsCommDeletedAlertText: 'Commento eliminato!',
  postDetailsCommentUserCurtainOptionTitle: 'Segnala commento',
  blogsCreatePostCurtainTitle: 'Nuovo post',
  blogsCreatePostCurtainBodyPlaceholder: 'Scrivi il tuo testo qui...',
  blogsCreatePostPublishButtonTitle: 'Pubblica',
  blogsCreatePostUploadSlallerImageAlertText: 'Puoi caricare al massimo {size} MB alla volta',
  blogsPostSavedAlertText: 'Post salvato!',
  blogsCreatePostAddLocationCurtainTitle: 'Posizione',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Nome posizione',
  blogsCreatePostEditLocationCurtainText: 'Modifica posizione',
  blogsDeleteLocation: 'Elimina posizione',
  blogsDiscardPostPopupTitle: 'Bozza',
  blogsDiscardPostPopupText: 'Eliminare questa bozza?',
  blogsDiscardPostPopupCancelButtonTitle: 'Annulla',
  blogsDiscardPostPopupCofirmButtonTitle: 'Conferma',
  blogsNewPostCreatePollTitle: 'Crea sondaggio',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Titolo',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Opzione',
  blogsNewPostCreatePollAddButtonTitle: 'Aggiungi opzione',
  blogsNewPostCreatePollCreateButtonTitle: 'Crea',
  blogsCreatePostPollTitleBlankAlertText: 'Il titolo non può essere vuoto!',
  blogsCreatePostPollOptionBlankAlertText: "L'opzione non può essere vuota!",
  blogsCreatePostPollLongTitleAlertText: 'Il titolo deve contenere al massimo {length} caratteri',
  blogsCreatePostPollLongOptionAlertText: "L'opzione deve contenere al massimo {length} caratteri",
  blogsCreatePostPollEditOptionTitle: 'Modifica sondaggio',
  blogsCreatePostPollRemoveOptionTitle: 'Rimuovi sondaggio',
  blogsPostPollInfoVotesText: 'voti',
  blogsPostPollInfoEditVoteText: 'Modifica voto',
  blogsPostPollFinishPollText: 'Termina il sondaggio',
  blogsPostPollFinishedPollText: 'Terminato',
  blogsPostPollInProgresslText: 'In corso',
  blogsFinishPollCurtainTitle: 'Termina il sondaggio',
  blogsFinishPollCurtainText: 'Gli utenti non potranno più votare dopo la chiusura del sondaggio.',
  blogsFinishPollCurtainCancelButtonTitle: 'Annulla',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Conferma',
  blogsPollInfoPollVotesCurtainTitle: 'Voti del sondaggio',
  blogsEditPostCurtainTitle: 'Modifica post',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Scrivi il tuo testo qui...',
  blogsEditPostCurtainSaveButtonTitle: 'Salva',
  blogsEditPostSavedAlertText: 'Post salvato!',
  blogsError: 'Qualcosa è andato storto!',
  blogsAt: 'alle',
  blogsSeeMore: 'Mostra altro...',
  blogsMaxAttachments: 'Hai superato il numero massimo di allegati. Il massimo è {length}',
  blogsReply: 'Rispondi',
  blogsAddCover: 'Aggiungi copertina'
}
